import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

export interface LayerData {
  opacity: number;
}

export interface LayerOpacityState {
  layers: Record<number, LayerData>;
  sublayers: Record<string, LayerData>;
  // we don't want more than one layer controls to be opened at a time
  openedLayerControlsId: string | null;
}

const initialState: LayerOpacityState = {
  layers: {},
  sublayers: {},
  openedLayerControlsId: null,
};

const layerOpacitySlice = createSlice({
  name: 'layerOpacity',
  initialState,
  reducers: {
    setLayerState: (
      state,
      {
        payload,
      }: PayloadAction<{
        layerId: number;
        layerData: LayerData;
      }>,
    ) => {
      state.layers[payload.layerId] = payload.layerData;
    },
    setSublayerState: (
      state,
      {
        payload,
      }: PayloadAction<{
        sublayerId: string;
        layerData: LayerData;
      }>,
    ) => {
      state.sublayers[payload.sublayerId] = payload.layerData;
    },
    setOpenedLayerControlsId: (
      state,
      { payload }: PayloadAction<string | null>,
    ) => {
      state.openedLayerControlsId = payload;
    },
    clearOpenedLayerControlsId: state => {
      state.openedLayerControlsId = null;
    },
  },
});

export const {
  setLayerState,
  setSublayerState,
  setOpenedLayerControlsId,
  clearOpenedLayerControlsId,
} = layerOpacitySlice.actions;

const persistConfig = {
  key: 'layerOpacity',
  storage,
};

export default persistReducer(persistConfig, layerOpacitySlice.reducer);
